import {library} from '@fortawesome/fontawesome-svg-core';
import {faClone} from '@fortawesome/pro-regular-svg-icons';
import {
    faBuilding,
    faCaretUp,
    faCheckCircle,
    faCog,
    faEye,
    faFileImport,
    faInfoCircle,
    faMinusCircle,
    faPencilAlt,
    faPlus,
    faPlusCircle,
    faSave,
    faSearch,
    faSparkle,
    faSparkles,
    faSpinner,
    faSquareTerminal,
    faTimes,
} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import Vue from 'vue';

library.add(
    faBuilding,
    faCaretUp,
    faCheckCircle,
    faClone,
    faCog,
    faEye,
    faFileImport,
    faInfoCircle,
    faSparkle,
    faSparkles,
    faMinusCircle,
    faPencilAlt,
    faPlus,
    faPlusCircle,
    faSave,
    faSearch,
    faSpinner,
    faSquareTerminal,
    faTimes,
);

Vue.component('FontAwesomeIcon', FontAwesomeIcon);
